import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38.902",
  height: "33",
  viewBox: "0 0 38.902 33"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "icon_login_change",
  transform: "translate(1.992 1.5)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M29.425,19.129A15,15,0,0,1,0,15c-.674,1.413-2.493,5.34-2.493,5.34",
    transform: "translate(2.493)",
    fill: "none",
    stroke: "#b52ac9",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M-2.493,25.871A15,15,0,0,1,26.932,30c.674-1.413,2.493-5.34,2.493-5.34",
    transform: "translate(5.493 -15)",
    fill: "none",
    stroke: "#b52ac9",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}